import request from "@/utils/request.js"

export default {
    source: {
        list: (params) => request.post("/api/Trend/TrendProduct/GetList", params),
        setCategory: (params) => request.get("/api/Trend/TrendProduct/SetCategory", { params })
    },
    category: {
        metas: (params) => request.get("/api/Trend/TrendProduct/AuthCategorys", { params }),
        sales: (params) => request.post("/api/Trend/TrendProduct/GroupCategory", params),
    },
    region: {
        metas: (params) => request.get("/api/Trend/TrendProduct/AuthRegions", { params }),
        sales: (params) => request.post("/api/Trend/TrendProduct/GroupRegion", params),
    },
    dealer: {
        group: (params) => request.post("/api/Trend/TrendProduct/GroupDealer", params),
        ranking: (params) => request.post("/api/Trend/TrendProduct/TopDealer", params),
        about: (params) => request.post("/api/Trend/TrendProduct/AboutDealer", params),
    },
    purchaser: {
        group: (params) => request.post("/api/Trend/TrendProduct/GroupPurchaser", params),
        ranking: (params) => request.post("/api/Trend/TrendProduct/TopPurchaser", params),
        about: (params) => request.post("/api/Trend/TrendProduct/AboutPurchaser", params),
    },
    product: {
        ranking: (params) => request.post("/api/Trend/TrendProduct/TopProduct", params)
    },
    groupMode: (params) => request.post("/api/Trend/TrendProduct/GroupMode", params),
    groupMonth: (params) => request.post("/api/Trend/TrendProduct/GroupMonth", params),
    groupVariety: (params) => request.post("/api/Trend/TrendProduct/GroupVariety", params),
}